import React from 'react'
import { logOutApi } from '../../Api/BarestSupplierServices'
import BottomNavigation from '../../Components/BottomNavigation/BottomNavigation'
import MenuSelection from '../../Components/MenuSelection/MenuSelection'
import { errorToast } from '../../Utils/Toast/Toast'
import Style from './Menu.module.css'
const colors=[
    '#EEEEEE',
    '#FFFBDE',
    '#F8ECFF',
    '#E5FFF1',
    '#FFEBDE',
    '#F9FFE5',
    '#DEEBFF',
    '#F8ECFF',
    '#F4FFEC',
    '#FFEBDE',
    '#FFFBDE'
]
const menuValue=[
    {
        src:'/Assets/Images/Menu/addproduct.png',
        title:'افزودن و ویرایش محصول',
        link:'/addproduct'
    },
    {
        src:'/Assets/Images/Menu/profile.png',
        title:'پروفایل',
        link:'/profile'
    },
    {
        src:'/Assets/Images/Menu/modiriatComment.png',
        title:'مدیریت نظرات',
        link:'/comments'
    },
    {
        src:'/Assets/Images/Menu/repoarts.png',
        title:'گزارش ها',
        link:'/repoarts'
    },
    {
        src:'/Assets/Images/Menu/off.png',
        title:'مدیریت تخفیف ها',
        link:'/managediscount'
    },
    {
        src:'/Assets/Images/Menu/accounting.png',
        title:'حسابداری',
        link:'/accounting'
    },
    {
        src:'/Assets/Images/Menu/support.png',
        title:'پشتیبانی',
        link:'/support'
    },
    {
        src:'/Assets/Images/Menu/situationOfSupplier.png',
        title:'وضعیت تامین کننده',
        link:'/supplier'
    }
]
const Menu = () => {

    const type=localStorage.getItem('type')

    const isLogin=()=>!!localStorage.getItem('supplierToken')
    const LogoutHandler=()=>{
        let info={
            logout:""
        }
        logOutApi(info,succ=>{
            if(isLogin()){
                if(succ.status===1){
                    localStorage.clear()
                    errorToast('خارج شدین')
                    window.location.reload()
                }
                else{
                    errorToast('خطایی رخ داده')
                }
            }
            else{
                errorToast('شما هنوز وارد نشدید!!')
            }
        })
    }
    return (
        <div className={Style.PageHolder}>
            <ul className={Style.MeniPartHolder}>
                {type==='food'?<li className={Style.MeniPartHolder__EachPart} style={{background:colors[0]}}>
                    <MenuSelection 
                    Imgsrc={'/Assets/Images/Menu/addmenu.svg'} 
                    title={'افزودن منو'} 
                    linkholder={'/addmenu'}/>
                    </li>:null
                }
                {type==='food'?<li className={Style.MeniPartHolder__EachPart} style={{background:colors[5]}}>
                    <MenuSelection 
                    Imgsrc={'/Assets/Images/Menu/category.svg'} 
                    title={'تعیین دسته بندی'} 
                    linkholder={'/choosecategory'}/>
                    </li>:null
                }
                {type==='food'?<li className={Style.MeniPartHolder__EachPart} style={{background:colors[6]}}>
                    <MenuSelection 
                    Imgsrc={'/Assets/Images/Menu/off.png'} 
                    title={'مدیریت مشتریان'} 
                    linkholder={'/managecustomer'}/>
                    </li>:null
                }
                {
                    menuValue.map((item,index)=>{
                        return(
                            <li key={index} className={Style.MeniPartHolder__EachPart} style={{background:colors[index+1]}}><MenuSelection Imgsrc={item.src} title={item.title} linkholder={item.link}/></li>
                        )
                    })
                }
                <li className={Style.MeniPartHolder__EachPart} style={{background:'#E5FFF1'}}>
                    
                    <div className={Style.MenuSelectionHolder} onClick={LogoutHandler}>
                        <div className={Style.ImageHolder}>
                            <img src={'/Assets/Images/Menu/exit.png'} alt='navigation' />
                        </div>
                        <p>خروج</p>
                    </div>
                </li>
            </ul>
            <BottomNavigation/>
        </div>
    )
}

export default Menu
